import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { ordenarPorLevenshteinConPeso} from "@/utils/helpers";

interface TablePdfInterface {
  tableName?: string
  data: Record<
    string,
    string | number | (string | number)[] | React.ReactNode
  >[]
  containTotals?: boolean
  displayTableTitles?: boolean,
  firstColumnLarger?: boolean
  lastColumnRight?: boolean
}

const TableTemplate = ({
  data,
  tableName,
  containTotals,
  displayTableTitles,
  firstColumnLarger = true,
    lastColumnRight = false
}: TablePdfInterface) => {
  let colNumber = 1
  let titles: string[] = []
  let body: (string | number | (string | number)[] | React.ReactNode)[][] = []

  data.forEach(item => {
    Object.keys(item).forEach((key) => {
      if (!titles.includes(key)) {
        titles.push(key)
      }
    })
  })
  titles = ordenarPorLevenshteinConPeso(titles)
  data.forEach((item, idx) => {
    colNumber = titles.length

    // Asegurar que cada fila tenga el mismo número de columnas que el encabezado
    const row: any[] = []
    titles.forEach(title => {
      if (item?.[title]) {
        row.push(item[title])
      }else {
        row.push('-')
      }
    })
    body.push(row)
  })

  //Styles
  const tableStyles = StyleSheet.create({
    tableTitle: {
      marginTop: 10,
      fontSize: 13,
      fontWeight: 'semibold',
      textDecoration: 'underline',
    },
    table: {
      marginTop: 5,
      paddingBottom: 10,
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      borderBottom: 'solid',
      borderBottomColor: '#7a7a7a',
      borderBottomWidth: 1,
    },
    rowHeader: {
      backgroundColor: '#000000',
      color: '#ffffff',
      fontWeight: 500,
    },
    col: {
      width: `${Math.floor((1 / colNumber) * 100)}%`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 5,
    },
    colx2: {
      width: `${Math.floor((1 / colNumber) * 100 * 2.5)}%`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      padding: 5,
    },
    headerText: {
      fontSize: 10,
      fontWeight: 500,
    },
    bodyText: {
      fontSize: 6,
    },
  })
  return (
    <>
      <View style={tableStyles.tableTitle} wrap={false}>
        <Text>{tableName}</Text>
      </View>
      <View style={tableStyles.table}>
        {/**header */}

        {(displayTableTitles === true || displayTableTitles === undefined) && (
          <View style={{ ...tableStyles.row, ...tableStyles.rowHeader }}>
            {titles.map((elem, idx) => (
              <View
                key={idx}
                style={idx === 0 && firstColumnLarger? tableStyles.colx2 : tableStyles.col}
              >
                <Text style={tableStyles.headerText}>{elem}</Text>
              </View>
            ))}
          </View>
        )}

        {/**body */}
        {body.map((elem, idx) => (
          <View
            key={idx}
            style={
              containTotals && idx === body.length - 1
                ? {
                    ...tableStyles.row,
                    backgroundColor: '#cbd5e1',
                    textAlign: 'left',
                  }
                : { ...tableStyles.row, textAlign: 'left' }
            }
          >
            {elem.map((data, idx) => {
              if (Array.isArray(data)) {
                return (
                  <View
                    key={idx}
                    style={idx === 0 &&
                    firstColumnLarger ?
                        lastColumnRight? {...tableStyles.colx2, justifyContent:'flex-end', alignItems: 'flex-end', textAlign: 'right'} : tableStyles.colx2
                        :
                        lastColumnRight? {...tableStyles.col, justifyContent:'flex-end', alignItems: 'flex-end', textAlign: 'right'} : tableStyles.col
                  }
                  >
                    {data.map((subitm, idx) => (
                      <Text key={idx} style={tableStyles.headerText}>
                        {subitm}
                      </Text>
                    ))}
                  </View>
                )
              }
              return (
                <View
                  key={idx}
                  style={
                    idx === 0 && firstColumnLarger
                      ? {
                          ...tableStyles.colx2,
                          fontWeight: 'ultrabold',
                          textAlign: 'left',
                        }
                      :
                      { ...tableStyles.col, textAlign: 'left' }
                  }
                >
                  <Text
                    style={{ ...tableStyles.headerText, textAlign: 'left' }}
                  >
                    {data}
                  </Text>
                </View>
              )
            })}
          </View>
        ))}
      </View>
    </>
  )
}

export default TableTemplate
